import { getAbsenceCategoryIcon, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import { absenceCategories, getAbsenceCategoryTranslationKey } from "@msuite/utils/absences";
import { getColorByString } from "@msuite/utils/colors";
import type { Enums } from "@msuite/utils/types";

/** Props Interface */
interface AbsencesInboxCategoriesProps {
	category: Enums<"absenceCategory"> | "all";
	setCategory: (category: Enums<"absenceCategory"> | "all") => void;
}

export function AbsencesInboxCategories({ category, setCategory }: AbsencesInboxCategoriesProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<SegmentedControl
			value={category}
			items={[
				{
					label: t("general.all"),
					value: "all",
					cyId: "absence-inbox-category-all",
				},
				...absenceCategories.map((category) => ({
					label: t(getAbsenceCategoryTranslationKey(category)),
					value: category,
					cyId: `absence-inbox-category-${category}`,
					leftIcon: (
						<Icon
							name={getAbsenceCategoryIcon(category)}
							color={`var(--color-${getColorByString(category)}-500)`}
						/>
					),
				})),
			]}
			onChange={setCategory}
		/>
	);
}
